export default __webpack_public_path__ + "static/media/kl-09.5746c117.png";